/**
 * Composition root: providers outside the router, routes inside.
 *
 * AuthProvider wraps BrowserRouter rather than the other way round, so the
 * mount-time session check runs once for the life of the app instead of
 * restarting on navigation.
 */

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.jsx';
import AppRoutes from './routes.jsx';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
